import { InstructorAuth } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// InstructorAuthServices contains functions to interact with the authentication-related APIs for the admin module.
// Each function corresponds to a specific API endpoint for tasks such as login, password change, forgot password, etc.
export const InstructorAuthServices = {
  /**
   * Function for user login.
   * @param {Object} values - User login credentials.
   * @returns {Promise<Object>} - A promise that resolves to the response from the login API.
   */
  instructorLogin: async (values) => {
    try {
      const payload = {
        ...InstructorAuth.instructorLogin,
        bodyData: values,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  instructorSignUp: async (values) => {
    try {
      const payload = {
        ...InstructorAuth.instructorSignup,
        bodyData: values,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
    getInstructorDataService: async () => {
      try {
        let payload = {
          ...InstructorAuth.getInstructorDetails,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
    changePasswordService: async (bodyData) => {
      try {
        const payload = {
          ...InstructorAuth.changePassword,
          bodyData,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
    logoutService: async () => {
      try {
        const payload = {
          ...InstructorAuth.accountLogout,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (err) {
        logger(err);
      }
    },
    verifyEmail: async (values) => {
      try {
        const payload = {
          ...InstructorAuth.verifyEmail,
          bodyData: values,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
    resendVerificationEmail: async (values) => {
      try {
        const payload = {
          ...InstructorAuth.resendVerificationEmail,
          bodyData: values,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
};
